<template>
  <div>
    <v-container class="pt-0 pb-5" v-if="is_document_still_editable">
      <v-row>
        <v-col>
          <div class="pa-2 rounded elevation-1 bg-white">
            <div>
              <SportipsButton backButton chevronLeft>Retour</SportipsButton>
            </div>
            <div class="text-h5 font-weight-bold text-darkblue my-2">Document de {{
              inscription.prenom }} {{ inscription.nom }}
            </div>
            <v-alert v-if="inscription.document_valide == 1" border="start" border-color="success" class="mb-2">
              <span
                v-if="inscription.coureur.champs.type_document.value == 'Licence' || inscription.coureur.champs.type_document.value == 'Autre licence'">La
                licence pour ce participant a été validée par l'organisateur</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Licence FFA'">La licence FFA pour ce
                participant a été validée par l'organisateur</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Certificat médical'">Le certificat
                médical pour ce participant a été validé par l'organisateur</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Pass Prévention Santé'">Votre
                numéro de PPS est validé</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Document PPS'">Votre
                PPS est validé</span>

              <span v-else>Cette inscription ne nécessite pas de document supplémentaire</span>
            </v-alert>
            <v-alert v-if="inscription.document_valide == 0 && inscription.document_recu == 1" border="start"
              border-color="success" class="mb-2">
              <span
                v-if="inscription.coureur.champs.type_document.value == 'Licence' || inscription.coureur.champs.type_document.value == 'Autre licence'">La
                licence pour ce participant est en attente de validation par l'organisateur</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Licence FFA'">La licence FFA pour ce
                participant est en attente de validation par l'organisateur</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Certificat médical'">Le certificat
                médical pour ce participant est en attente de validation par l'organisateur</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Document PPS'">Le PPS pour ce
                participant est en attente de validation par l'organisateur</span>
              <span v-else>Le document pour ce participant est en attente de validation par l'organisateur</span>
            </v-alert>
            <v-alert v-if="inscription.document_recu == 0" border="start" border-color="error" class="mb-2">
              <span
                v-if="inscription.coureur.champs.type_document.value == 'Licence' || inscription.coureur.champs.type_document.value == 'Autre licence'">Vous
                n'avez pas encore envoyé votre licence</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Licence FFA'">Vous n'avez pas encore
                envoyé votre licence FFA</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Certificat médical'">Vous n'avez pas
                encore envoyé votre certificat médical</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Document PPS'">Vous n'avez pas
                encore envoyé votre PPS</span>
              <span v-else-if="inscription.coureur.champs.type_document.value == 'Pass Prévention Santé'">Vous
                n'avez pas encore renseigné de numéro de PPS valide pour cette inscription</span>
              <span v-else>Vous n'avez pas encore envoyé votre document, veuillez sélectionner le type de document
                justificatif et importer le fichier afin de valider votre inscription</span>
            </v-alert>
            <div v-if="inscription.document_valide == 0">
              <v-alert class="my-2" v-if="pps_is_document_selected">
                <div>Afin de valider votre inscription, vous devez renseigner un numéro de PPS valide. Les informations
                  de votre PPS doivent être STRICTEMENT identiques à celles de votre fiche d'inscription.<br> ATTENTION
                  :
                  NOM ou Prénom composés -> Vérifiez si un espace ou un tiret ( - ) est indiqué.
                  Si les informations sont différentes veuillez refaire votre PPS avec une saisie identique.
                  <br>Si une erreur s'est glissée dans votre date de naissance, vous pouvez <a
                    style="cursor: pointer;text-decoration: underline !important;"
                    @click="$router.push({ name: 'EditInscription', params: { id_inscription: $route.params.id_inscription } })"><v-icon
                      icon="mdi-pen"></v-icon> corriger votre Jour
                    ou Mois
                    de
                    naissance</a>. Pour rappel:
                </div>
                <div><b>Nom: </b>{{ inscription.coureur.champs.nom.value }}</div>
                <div><b>Prénom: </b>{{ inscription.coureur.champs.prenom.value }}</div>
                <div><b>Sexe: </b>{{ inscription.coureur.champs.sexe.value }}</div>
                <div><b>Date de naissance: </b>{{ get_french_date(inscription.coureur.champs.date_naissance.value) }}
                </div>



              </v-alert>

              <v-form ref="formDocumentCoureur" v-model="valid" class="mb-5 mt-4" v-if="inscription.coureur.champs">
                <v-row>
                  <v-col md="6" cols="12" class="py-0" v-for="(champ, index_champ) in get_editable_field"
                    :key="index_champ">
                    <div>


                      <Champ_Select_Document v-if="champ.nom == 'type_document'" :champ="champ"
                        :inscription="inscription" :in_edit="true" @validate_mineur="validate"
                        @validate_moins_12="validate"></Champ_Select_Document>
                      <Champ_Document v-if="champ.type == 'document'" :champ="champ" :inscription="inscription"
                        @uploadDocument="validate"></Champ_Document>
                      <Champ_PPS v-if="champ.nom == 'numero_pps'" :champ="champ" :inscription="inscription"
                        :allow_identity_correction="true" @pps_validated="validate"></Champ_PPS>
                      <Champ_Boolean v-if="champ.type == 'boolean'" :champ="champ" :inscription="inscription">
                      </Champ_Boolean>


                      <div v-if="champ.nom == 'licence' && display_licence_form">

                        <Champ_Licence :champ="champ" :inscription="inscription" @licence_validated="validate">
                        </Champ_Licence>
                        <v-btn color="primary-dark" @click="validate" variant="elevated" elevation="0">Enregistrer ma
                          licence</v-btn>
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-btn color="primary-dark" @click="validate" variant="elevated" elevation="0">Enregistrer mes
                  documents</v-btn>
              </v-form>

            </div>

            <v-alert color="dark-red" variant="tonal" class="mb-2" v-for="(error, index_error) in errors"
              :key="index_error" type="error">
              {{ error }}
            </v-alert>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else>
      <div class="pa-2 rounded elevation-1 bg-white">
        <v-alert variant="tonal" type="error">Le module d'inscription est clos. Vous ne pouvez plus modifier vos
          documents pour cette inscription.</v-alert>
      </div>
    </v-container>
    <v-dialog v-model="display_confirm_dialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-h6">Modification du document</div>
          <p>Vos documents ont bien été modifiées.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary-dark" text @click="onCloseDialog">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import Inscription from "@/classes/Fiche_Coureur/Inscription.class";
import List_Champs_Formulaire from "@/classes/Champs_Formulaire/List_Champs_Formulaire.class";
import Champ_Select_Document from "@/components/Inscription/Champs_Formulaire/Champ_Select_Document.vue";
import Champ_Document from "@/components/Inscription/Champs_Formulaire/Champ_Document.vue";
import Champ_PPS from "@/components/Inscription/Champs_Formulaire/Champ_PPS.vue";
import Champ_Licence from "@/components/Inscription/Champs_Formulaire/Champ_Licence.vue";
import Champ_Boolean from "@/components/Inscription/Champs_Formulaire/Champ_Boolean.vue";
export default {
  components: {
    Champ_Select_Document,
    Champ_Document,
    Champ_PPS,
    Champ_Licence,
    Champ_Boolean,
  },
  data() {
    return {
      errors: [],
      inscription: {},
      list_champs_formulaires: {},
      valid: false,
      display_confirm_dialog: false,
    };
  },

  computed: {
    ...mapStores(useMainStore),
    is_document_still_editable() {
      if (this.mainStore.module.status == "apres_fermeture" && !this.mainStore.module.metadatas.accueil_par_qrcode) {
        return false;
      }
      return true;
    },
    display_licence_form() {

      return this.has_selected_licence && !this.has_champ_licence_document;
    },
    has_champ_document() {
      // parcourir les champs de l'inscription
      for (let champ_label in this.inscription.coureur.champs) {
        let champ = this.inscription.coureur.champs[champ_label];
        if (champ.type == "document") {
          if (champ.nom == "licence_document" || champ.nom == "autre_licence_document") {
            return true;
          }
        }
      }
      return false;
    },
    pps_is_document_selected() {
      return this.inscription.coureur.champs.type_document.value == "Pass Prévention Santé";
    },
    get_editable_field() {

      let editable = {};
      let editable_fields = ["type_document", "cm_document", "licence_document", "autre_licence_document", "numero_pps", "pps_document", "fis_document", "fichier_pass_competition", "licence", "licence_ffco_document", "questionnaire_ffco_document", "regles_or_ffco"];
      if (this.inscription.requires_vague_justificatif()) {
        editable_fields.push("justificatif_vague_document");
      }
      const champs_met = this.inscription.coureur.get_list_champs_meet_conditions(this.inscription);
      for (let i = 0; i < editable_fields.length; i++) {
        const field_name = editable_fields[i];
        if (champs_met[field_name]) {
          editable[field_name] = champs_met[field_name];
          continue;
        }
        if (this.inscription.coureur.champs[field_name] && this.condition_meet(this.inscription.coureur.champs[field_name])) {
          editable[field_name] = this.inscription.coureur.champs[field_name];
        }
      }


      return editable;
    },
    has_selected_licence() {
      const type_document = this.inscription?.coureur?.champs?.type_document?.value;
      if (!type_document) {
        return false;
      }
      if (type_document.includes("FFCO")) {
        return false;
      }
      if (type_document.includes("Licence")) {
        return true;
      }

      return false;
    },
  },

  methods: {
    get_french_date(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    async onCloseDialog() {
      this.display_confirm_dialog = false;
      await this.handle_access_initialization();
      this.inscription.align_coureur_infos_with_inscription();
      this.list_champs_formulaires = new List_Champs_Formulaire();
      this.list_champs_formulaires.list_ids_parcours = [this.inscription.id_course];
      this.list_champs_formulaires.id_module = this.mainStore.module.id;
      await this.list_champs_formulaires.fetch();
      this.inscription.coureur.rebuild_list_champs(this.list_champs_formulaires.list, this.inscription);
    },
    condition_meet(champ) {
      if (!champ.condition_nom || champ.condition_nom === "") {
        return true;
      }
      for (let champ_condition_label in this.inscription.coureur.champs) {
        let champ_condition = this.inscription.coureur.champs[champ_condition_label];
        if (champ_condition.nom == champ.condition_nom) {
          return champ.condition_met(champ_condition.value);
        }
      }
      return true;
    },
    async handle_update_document() {
      let is_auth = this.mainStore.authUser.isLogged;
      let is_token_provided = this.$route.query.token && this.$route.query.token != "";
      if (is_token_provided) {
        let update_coureur = await this.inscription.update_document_by_token(this.$route.query.token);
        if (update_coureur) {
          this.display_confirm_dialog = true;
        } else {
          this.errors.push("Une erreur est survenue lors de la modification de vos informations. Merci de réessayer ultérieurement.");
        }
        return;
      }
      if (is_auth) {
        let update_coureur = await this.inscription.update_document();
        if (update_coureur) {
          this.display_confirm_dialog = true;
        } else {
          this.errors.push("Une erreur est survenue lors de la modification de vos informations. Merci de réessayer ultérieurement.");
        }
        return;
      }
    },

    async validate() {
      this.errors = [];
      let res = await this.$refs.formDocumentCoureur.validate();
      if (res.valid) {
        await this.handle_update_document();
        return;
      } else {
        for (let champ of Object.values(this.get_editable_field)) {
          if (champ.mandatory == "1" && champ.value == "") {
            this.errors.push("Le champ " + champ.label + " est requis");
          }
        }
        if (this.errors.length > 0) {
          return;
        }
        await this.handle_update_document();
        return;

      }




    },

    /* Vérifie le mode d'authentification (par compte connecté ou token d'authentification) */
    async handle_access_initialization() {
      let is_auth = this.mainStore.authUser.isLogged;
      let is_token_provided = this.$route.query.token && this.$route.query.token != "";
      if (is_token_provided) {
        await this.token_initialization();
        return;
      }
      if (is_auth) {
        await this.auth_initialization();
        return;
      }
      this.$router.push({ name: "FicheCoureur" });
    },
    async auth_initialization() {
      this.inscription = new Inscription();
      this.inscription.id = this.$route.params.id_inscription;
      let request = await this.inscription.get();
      if (!request) {
        this.$router.push({ name: "FicheCoureur" });
      }
    },
    async token_initialization() {
      this.inscription = new Inscription();
      let request = await this.inscription.get_by_token(this.$route.query.token);
      if (!request) {
        this.$router.push({ name: "FicheCoureur" });
      }
    },
  },
  async created() {
    await this.handle_access_initialization();

    this.inscription.align_coureur_infos_with_inscription();

    this.inscription.populate_coureur_infos_with_inscription();

    this.inscription.list_courses.id_module = this.inscription.id_module || this.mainStore.module.id;
    await this.inscription.list_courses.fetch();
    this.inscription.set_selected_course();

    this.list_champs_formulaires = new List_Champs_Formulaire();
    this.list_champs_formulaires.list_ids_parcours = [this.inscription.id_course];
    this.list_champs_formulaires.id_module = this.mainStore.module.id;
    await this.list_champs_formulaires.fetch();
    this.inscription.coureur.rebuild_list_champs(this.list_champs_formulaires.list, this.inscription);

  },
};
</script>

<style lang="scss">
.v-field--disabled {
  opacity: 0.8 !important;
}
</style>